import { useLocation } from 'react-router-dom';

import SelectPlanCheckoutView from 'components/Checkout';
import { SelectPlanGlobalStyles } from 'components/Checkout/styles';
import CheckoutContextProvider from 'contexts/CheckoutContextProvider';
import useChangePage from 'hooks/useChangePage';
import { TRIAL_URL } from 'routes/constants';

import { BUY_NOW_MODAL_ROUTE } from '../../constants';

const TRIAL_CHECKOUT_INDEX_ROUTE = `${TRIAL_URL}/${BUY_NOW_MODAL_ROUTE}`;

const BuyNowWithDiscountAndCheckout = () => {
  const changePage = useChangePage();
  const { pathname } = useLocation();
  const closeCheckoutPage = () => changePage(TRIAL_CHECKOUT_INDEX_ROUTE);

  return (
    <CheckoutContextProvider isFromTrial>
      <SelectPlanGlobalStyles />
      <SelectPlanCheckoutView
        closeCheckoutPage={
          pathname !== TRIAL_CHECKOUT_INDEX_ROUTE ? closeCheckoutPage : null
        }
        isTrial
      />
    </CheckoutContextProvider>
  );
};

export default BuyNowWithDiscountAndCheckout;
